import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import { deleteOrder, getAllGiftOrders, updateOrder, updateGiftOrder, getActiveDrivers, sendTirpByDriverId } from '../../shared/api/user';
import { useState, useEffect } from 'react';
import moment from 'moment';
import Box from '@mui/material/Box';
import { useNavigate } from "react-router-dom";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function BasicTable() {
    const [orders, setOrders] = useState([]);
    const [Offset, setOffset] = useState(0);
    const [drivers, setDrivers] = useState([]);
    const [selectedTripId, setSelectedTripId] = useState('');
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
   const [selectedStatus, setSelectedStatus] = useState({});


    const handleClose = () => {
        setOpen(false);
    };


    const init = async () => {
        let rows = await getAllGiftOrders(15, Offset);
        console.log(rows.data.giftOrders)
        setOrders(rows.data.giftOrders);
    }

    useEffect(() => {
        init();
    }, []);

    async function deleteOrderById(id) {
        // let status = await deleteOrder(id);
        // init();
    }

    async function paginationClickedNext() {
        setOffset(Offset + 15);
        init();
    }

    async function paginationClickedPrev() {
        if (Offset > 0) {
            setOffset(Offset - 15);
            init();
        }
    }

    const details = async (id) => {
        navigate(`/gift/order/${id}`);
    }

    const sendOrderToChef = async (id) => {
        await updateOrder(id, { orderStatus: 'PENDING' });
        init();
    }

    const sendOrderUpdate = async (id, update) => {
        await updateGiftOrder(id, { orderStatus: update });
        init();
    }

    const getDrivers = async (id) => {
        setSelectedTripId(id);
        let drivers = await getActiveDrivers(id);
        setDrivers(drivers.drivers);
        console.log(drivers);
        setOpen(true);
    }

    const sendTripToDriverById = async (driverId) => {
        let trip = await sendTirpByDriverId(selectedTripId, driverId);
        console.log(trip)
        setOpen(false);
    }

    return (
        <>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Customer Name</TableCell>
                            <TableCell align="left">Item</TableCell>
                            <TableCell align="right">Order Status</TableCell>
                            <TableCell align="right">Order Type</TableCell>
                            <TableCell align="right">Payment Status</TableCell>
                            <TableCell align="right">Total Price</TableCell>
                            <TableCell align="left">Approval</TableCell>
                            <TableCell align="left">Broadcast</TableCell>
                            <TableCell align="right">Delete Order</TableCell>
                            <TableCell align="right">Order Time</TableCell>
                            <TableCell align="center">Status Action</TableCell>                   
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {orders?.map((row) => (
                            <TableRow
                                key={row._id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align="left" style={{ cursor: 'pointer' }} onClick={() => details(row._id)}>{row?.user?.firstName} {row?.user?.lastName || ''}</TableCell>
                                <TableCell align="left" style={{ cursor: 'pointer' }} onClick={() => details(row._id)}>{row?.orderItems[0]?.gift?.name}</TableCell>
                                <TableCell align="right" style={{ cursor: 'pointer' }} onClick={() => details(row._id)}>{row?.orderStatus}</TableCell>
                                <TableCell align="right" style={{ cursor: 'pointer' }} onClick={() => details(row._id)}>{row?.orderType}</TableCell>
                                <TableCell align="right" style={{ cursor: 'pointer' }} onClick={() => details(row._id)}>{row?.paymentStatus}</TableCell>
                                {!row.foodOrderId && <TableCell align="right" style={{ cursor: 'pointer' }} onClick={() => details(row._id)}>{`Rs. ${(row.total).toFixed(2)}`}</TableCell>}
                                {row.foodOrderId && <TableCell align="right" style={{ cursor: 'pointer' }} onClick={() => details(row._id)}>{`Rs. ${(row.foodOrderId?.serviceFee + row.total).toFixed(2)}`}</TableCell>}
                                {row.foodOrderId && row.foodOrderId.orderStatus === 'ON_HOLD' && <TableCell align="left"><Button onClick={() => sendOrderToChef(row.foodOrderId._id)} variant="text">Send to chef</Button></TableCell>}
                                {row.foodOrderId && row.foodOrderId.orderStatus === 'PENDING' && <TableCell align="left">Waiting for restaurant approval</TableCell>}
                                {row.foodOrderId && row.foodOrderId.orderStatus === 'ACCEPTED' && <TableCell align="left">Accepted</TableCell>}
                                {row.foodOrderId && row.foodOrderId.orderStatus === 'IN_PROGRESS' && <TableCell align="left">In progress</TableCell>}
                                {row.foodOrderId && row.foodOrderId.orderStatus === 'COMPLETED' && <TableCell align="left">COMPLETED</TableCell>}
                                {!row.foodOrderId && row.orderStatus === 'PENDING' && <TableCell align="left"><Button onClick={() => sendOrderUpdate(row._id, 'ACCEPTED')} variant="text">Accept</Button></TableCell>}
                                {!row.foodOrderId && row.orderStatus === 'ACCEPTED' && <TableCell align="left"><Button onClick={() => sendOrderUpdate(row._id, 'IN_PROGRESS')} variant="text">Start processing</Button></TableCell>}
                                {!row.foodOrderId && row.orderStatus === 'IN_PROGRESS' && <TableCell align="left"><Button onClick={() => sendOrderUpdate(row._id, 'COMPLETED')} variant="text">Ready</Button></TableCell>}
                                {!row.foodOrderId && row.orderStatus === 'COMPLETED' && <TableCell align="left">Completed</TableCell>}
                                {!row.foodOrderId && row.orderStatus === 'ACCEPTED' && <TableCell align="right"><Button onClick={() => getDrivers(row.tripId)} variant="text">Get Drivers</Button></TableCell>}
                                {!row.foodOrderId && row.orderStatus !== 'ACCEPTED' && <TableCell align="right">Order not accepted</TableCell>}
                                {row.foodOrderId && <TableCell align="right">Not Available</TableCell>}
                                <TableCell align="right"><Button onClick={() => deleteOrderById(row._id)} variant="text"><DeleteIcon></DeleteIcon></Button></TableCell>
                                <TableCell align="right" style={{ cursor: 'pointer' }} onClick={() => details(row._id)}>{moment(row.createdAt).format('MMM Do YY, h:mm a')}</TableCell>
                                 <TableCell align="center">
                                    <select
                                        value={selectedStatus[row._id] || ''}
                                        onChange={(e) =>
                                        setSelectedStatus({ ...selectedStatus, [row._id]: e.target.value })
                                        }
                                        style={{ marginRight: '10px', padding: '5px' }}
                                    >
                                        <option value="">Select Status</option>
                                        {row.orderStatus !== 'COMPLETED' && (
                                        <option value="COMPLETED">Completed</option>
                                        )}
                                        {row.orderStatus !== 'IN_PROGRESS' && (
                                        <option value="IN_PROGRESS">In-Progress</option>
                                        )}
                                    </select> 

                                    <Button
                                        sx={{ color: '#CB2704' }}
                                        variant="text"
                                        onClick={async () => {
                                        if (!selectedStatus[row._id]) {
                                            alert('Please select a status first');
                                            return;
                                        }

                                        try {
                                            await updateGiftOrder(row._id, {
                                            orderStatus: selectedStatus[row._id],
                                            });
                                            alert(`Order status updated to ${selectedStatus[row._id]}`);
                                            init(); // refresh the table
                                        } catch (error) {
                                            alert('Failed to update order status');
                                            console.error('Update error:', error);
                                        }
                                        }}
                                    >
                                        Update Status
                                    </Button>
                                    </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <Box textAlign='center'>
                    <Button onClick={() => paginationClickedNext()} variant="text">Load next</Button>
                    {Offset > 0 && <Button onClick={() => paginationClickedPrev()} variant="text">Load previous</Button>}
                </Box>
            </TableContainer>

            <BootstrapDialog
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'md'}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Available Drivers
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">Driver Name</TableCell>
                                    <TableCell align="left">Phone</TableCell>
                                    <TableCell align="left">Vehicle Type</TableCell>
                                    <TableCell align="right">Send Trip</TableCell>
                                    <TableCell align="center">Status Action</TableCell>                      
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {drivers?.map((row) => (
                                    <TableRow
                                        key={row._id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell align="left" style={{ cursor: 'pointer' }}>{row?.firstName} {row?.lastName || ''}</TableCell>
                                        <TableCell align="left" style={{ cursor: 'pointer' }}>{row?.phoneNumber}</TableCell>
                                        <TableCell align="left" style={{ cursor: 'pointer' }}>{row?.vehicle.type}</TableCell>
                                        <TableCell align="right" style={{ cursor: 'pointer' }}><Button onClick={() => sendTripToDriverById(row._id)} variant="text">Send Trip Request</Button></TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
            </BootstrapDialog>
        </>

    );
}